
import { Column } from "primereact/column";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import { InputText } from "primereact/inputtext";
import CreateClassroomModal from "./CreateClassroomModal";
import classroomsAPI from "../../../../services/classrooms";
import UpdateClassroomModal from "./UpdateClassroomModal";
import { useNavigate, useParams } from "react-router-dom";
import { PERMISSION_TRAINING_CLASSROOMS } from "../../../../permissions";
import MeaButton from "../../../../components/MeaButton";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaLink from "../../../../components/MeaLink";

const ClassroomsListComponent = forwardRef((props, ref) => {
  const { selectedFields, showAddButton } = props;
  const { auth, hasPermission } = useAuthContext();
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const navigate = useNavigate();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const accessToken = auth?.access_token;
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  let selectedData = {
    name: selectedFields?.name ?? true,
    presentation: selectedFields?.age ?? true,
    capacity: selectedFields?.level ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  const [classroom, setClassroom] = useState(null);
  //
  const queryList = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <>
          <MeaButton
            label="Créer une salle"
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouvelle salle"
            permission={PERMISSION_TRAINING_CLASSROOMS.CREATE}
          />
          <MeaButton disabled={true} icon="pi pi-cloud-upload" label="Importer" size="small" className="p-button mr-2" outlined
            onClick={() => {
              navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/classrooms-import");
            }}
            data-pr-tooltip="Importer"
            permission={PERMISSION_TRAINING_CLASSROOMS.CREATE}
          />
        </>
      )}
    </div>
  );
  //
  return (
    <>
      <CreateClassroomModal ref={createModalRef} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
      <MeaDataTable
        query={queryList}
        serviceAPI={classroomsAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        names={{ pagination: "classroom", singular: "salle", plural: "salles" }}
        startToolbarTemplate={startToolbarTemplate}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_CLASSROOMS.DELETE)}
        //showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        {selectedData.name && (
          <Column
            field="name"
            header="Salle"
            editor={(options) => (
              <InputText
                type="text"
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
              />
            )}
            body={(item) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classrooms/" +
                  item.id
                }
                permission={PERMISSION_TRAINING_CLASSROOMS.GET}
              >
                {item.name}
              </MeaLink>
            )}
          ></Column>
        )}
        {selectedData.presentation && (
          <Column field="presentation" header="Presentation"></Column>
        )}
        {selectedData.capacity && (
          <Column
            field="capacity"
            header="Capacité"
            style={{ width: "20%" }}
            editor={(options) => (
              <InputText
                type="number"
                value={options.value}
                onChange={(e) => options.editorCallback(Number(e.target.value))}
              />
            )}
          ></Column>
        )}
        {selectedData.edit && (
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setClassroom(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_CLASSROOMS.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateClassroomModal ref={updateModalRef} schoolId={schoolId} trainingId={trainingId} classroom={classroom} />
    </>
  );
});

export default ClassroomsListComponent;
